import { cardOutline } from 'ionicons/icons'
import { Divider, Icon, Title, Wrapper } from './styled'

type PayCardContentProps = {
  cardNumber: string
}

export function PayCardContent({ cardNumber }: PayCardContentProps) {
  return (
    <Wrapper>
      <Icon icon={cardOutline} />
      <Divider />
      <Title>{cardNumber}</Title>
    </Wrapper>
  )
}
